<div [formGroup]="customAttributeDefinitionForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="externalId"
    placeholder="coreModuleModule.customAttributeDefinitionDialogComponent.form.externalId.placeholder"
    label="coreModuleModule.customAttributeDefinitionDialogComponent.form.externalId.label">
  </nx-edit-text-input>
  <nx-edit-select-input
    formControlName="type"
    placeholder="coreModuleModule.customAttributeDefinitionDialogComponent.form.type.placeholder"
    label="coreModuleModule.customAttributeDefinitionDialogComponent.form.type.label"
    [options]="typeOptions | translateLabels">
  </nx-edit-select-input>
  <nx-edit-text-input
    formControlName="label"
    placeholder="coreModuleModule.customAttributeDefinitionDialogComponent.form.url.placeholder"
    label="coreModuleModule.customAttributeDefinitionDialogComponent.form.url.label">
  </nx-edit-text-input>
  <nx-edit-number-input
    formControlName="index"
    [placeholder]="'1'"
    [helpText]="isAdmin() ? 'coreModuleModule.customAttributeDefinitionDialogComponent.form.index.helpTextAdmin' : 'coreModuleModule.customAttributeDefinitionDialogComponent.form.index.helpText'"
    label="coreModuleModule.customAttributeDefinitionDialogComponent.form.index.label">
  </nx-edit-number-input>
  <nx-edit-text-input
    formControlName="key"
    placeholder="coreModuleModule.customAttributeDefinitionDialogComponent.form.key.placeholder"
    label="coreModuleModule.customAttributeDefinitionDialogComponent.form.key.label">
  </nx-edit-text-input>
  <nx-edit-text-input 
    formControlName="conversionExpression"
    placeholder="coreModuleModule.customAttributeDefinitionDialogComponent.form.conversionExpression.placeholder"
    label="coreModuleModule.customAttributeDefinitionDialogComponent.form.conversionExpression.label">
  </nx-edit-text-input>
<div>